/**
 * Internal dependencies
 */
import './custom-sources-backwards-compatibility';
import './default-autocompleters';
